<template>
  <div class="login-view">
    <div class="login-form">
      <div class="login-logo" style="width: fit-content">
        <img src="@/assets/logos/full_logo.png" alt="" style="height:70px;">
      </div>
      <div class="login-form-details" style="margin-top: 1em">
        <h2>Strong Room - Company Registration</h2>

        <div v-if="onboardingResults" style="width: 100%;">
          <p style="font-size: 1em;">Company has been successfully registered. Share these credentials with each user
            — passwords are only shown once.</p>
          <table class="onboarding-results-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Role</th>
                <th>Password</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="result in onboardingResults" :key="result.email">
                <td>{{ result.email }}</td>
                <td>{{ result.role }}</td>
                <td>{{ result.password }}</td>
              </tr>
            </tbody>
          </table>
          <div style="margin-top: 2em; display: flex; justify-content: center;">
            <p @click="registerAnother()" class="blue-button"
              style="width: fit-content; padding: 5px 15px; font-weight: bold; font-size: 1em; border-radius: 8px;">
              Register Another Company</p>
          </div>
        </div>

        <div v-else style="display: flex; flex-wrap: wrap">
          <div class="login-form-fields slide-fade">
            <div class="form-field wide-text-field" style="width: 80%;">
              <label for="first_name">Company Name <span style="color: red;">*</span></label>
              <input type="text" style="position: relative; width: 26em; background-color: #E5F1FE;"
                v-model="registerCompany.company_name" placeholder="Enter Company Name *">
            </div>
            <div class="form-field wide-text-field" style="width: 80%;">
              <label for="first_name">Facility Name <span style="color: red;">*</span></label>
              <input type="text" style="position: relative; width: 26em; background-color: #E5F1FE;"
                v-model="registerCompany.facility_name" placeholder="Enter Facility Name *">
            </div>
            <div class="form-field wide-text-field" style="width: 95%;">
              <label for="company_type">Company Type <span style="color: red;">*</span></label>
              <Dropdown v-model="registerCompany.company_type" :options="companyTypes"
                :placeholder="'Select company type'" />
            </div>
            <div class="form-field wide-text-field" style="width: 95%;">
              <label for="contact_name">Branch State <span style="color: red;">*</span></label>
              <Dropdown v-model="registerCompany.state_id" :options="states" optionValue="id" optionLabel="code"
                :placeholder="'Select state'" />
            </div>
            <div class="form-field wide-text-field" style="width: auto">
              <label>Enabled Features</label>
              <div class="feature-flags">
                <label><input type="checkbox" v-model="registerCompany.ecdr_active"> eCDR</label>
                <label><input type="checkbox" v-model="registerCompany.patient_admin_active"> Patient Admin</label>
                <label><input type="checkbox" v-model="registerCompany.eprescribing_active"> ePrescribing</label>
                <label><input type="checkbox" v-model="registerCompany.reporting_active"> Reporting</label>
                <label><input type="checkbox" v-model="registerCompany.enmrc_eprescribing_active"> eNRMC
                  ePrescribing</label>
                <label><input type="checkbox" v-model="registerCompany.patient_own_bags_active"> Patient Own
                  Bags</label>
                <label><input type="checkbox" v-model="registerCompany.requisitions_active"> Requisitions</label>
                <label><input type="checkbox" v-model="registerCompany.batch_features_active"> Batch
                  Features</label>
                <label><input type="checkbox" v-model="registerCompany.analytics_active"> Analytics</label>
              </div>
            </div>
          </div>
          <div class="login-form-fields slide-fade">
            <!-- CONTACT METHODS -->
            <div class="form-field wide-text-field" style="width: 80%;">
              <label for="first_name">Company E-mail<span style="color: red;">*</span></label>
              <input placeholder="Enter Company E-mail" v-model="registerCompany.contact_methods[0].data" type="text"
                style="position: relative; width: 26em; background-color: #E5F1FE;" />
            </div>
            <div class="form-field wide-text-field" style="width: 80%;">
              <label for="first_name">Admin email<span style="color: red;">*</span></label>
              <input placeholder="Enter Admin Email" v-model="registerCompany.admin_email" type="text"
                style="position: relative; width: 26em; background-color: #E5F1FE;" />
            </div>
            <div class="form-field wide-text-field" style="width: 80%;">
              <label>Additional Users</label>
              <div v-for="(email, index) in registerCompany.user_emails" :key="index"
                style="display: flex; align-items: center; gap: 0.5em; margin-bottom: 0.5em;">
                <input placeholder="Enter User Email" v-model="registerCompany.user_emails[index]" type="text"
                  style="position: relative; width: 22em; background-color: #E5F1FE;" />
                <span @click="removeUserEmail(index)" style="cursor: pointer; color: #E04F39;">✕</span>
              </div>
              <p @click="addUserEmail()" style="cursor: pointer; color: #0870DC; font-weight: bold; width: fit-content;">
                + Add another user</p>
            </div>
            <div class="form-field wide-text-field" style="width: auto">
              <label for="first_name">Address:<span style="color: red;">*</span></label>
              <div class="form-field text-field" style="width: 100%; margin-top: 0">
                <vue-google-autocomplete id="contactmap" classname="form-control"
                  :placeholder="'1 Apple Street, Melbourne, VIC 3000'" v-on:placechanged="getCompanyAddressData"
                  :country="$store.state.country">
                </vue-google-autocomplete>
              </div>
            </div>
            <!--  END OF CONTACT METHODS -->
          </div>
        </div>

        <div v-if="!onboardingResults" style="margin-top: 2em; display: flex; justify-content: center; margin-right: 1em;">
          <p @click="submitRegistration()" class="blue-button"
            style="width: fit-content; padding: 5px 15px; font-weight: bold; font-size: 1em; border-radius: 8px; ">
            Register</p>
        </div>

        <p v-if="registrationError" style="color: red; font-size: 1em;">Error: {{ registrationError }}</p>

        <SuccessModal @close="close" v-if="displaySuccessModal" :message="successMessage"
          :first_spec_line="first_spec_line" :second_spec_line="second_spec_line" />
      </div>
    </div>
    <div class="login-context">

      <div class="login-logo" style="display: grid; justify-content: flex-end">
        <img src="@/assets/logos/short_logo.png" alt="" style="height:70px;">
      </div>
      <h1 style="margin-top: 3em; ">The AI-Driven Drug Management Platform</h1>

      <p style="font-size: 1.4em; font-weight: 500">Powering a secure digital gateway to quickly and safely access
        specialised treatment plans for patients.</p>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import axios from 'axios';
import SuccessModal from '@/components/modals/SuccessModal.vue';

export default {
  components: {
    SuccessModal
  },
  data() {
    return {
      displaySuccessModal: false,
      first_spec_line: '',
      second_spec_line: '',
      successMessage: '',
      registrationError: '',
      company_name: '',
      companyTypes: ['aged care', 'clinic', 'dental', 'warehouse', 'head office', 'vet', 'ambulance', 'hospital', 'surgery'],
      onboardingResults: null,
      registerCompany: this.defaultRegisterCompany(),
      timezones: [],
      states: []
    }
  },
  methods: {
    defaultRegisterCompany() {
      return {
        company_name: '',
        facility_name: '',
        state_id: '',
        company_type: 'aged care',
        address: {
          state: '',
          country: '',
          street_address: '',
          postcode: '',
          suburb: '',
          city: ''
        },
        contact_methods: [
          {
            name: 'Email',
            data: '',
            type: 'email'
          }
        ],
        admin_email: '',
        user_emails: [],
        ecdr_active: false,
        patient_admin_active: false,
        eprescribing_active: false,
        reporting_active: false,
        enmrc_eprescribing_active: false,
        patient_own_bags_active: false,
        requisitions_active: false,
        batch_features_active: false,
        analytics_active: false
      };
    },
    close(value) {
      if (value) {
        this.displaySuccessModal = false;
        this.$router.push('/login');
      }
    },
    addUserEmail() {
      this.registerCompany.user_emails.push('');
    },
    removeUserEmail(index) {
      this.registerCompany.user_emails.splice(index, 1);
    },
    registerAnother() {
      this.onboardingResults = null;
      this.registerCompany = this.defaultRegisterCompany();
      if (this.$route.path.includes('/warehouse/')) {
        this.registerCompany.company_type = 'warehouse';
      }
      
      const mapInput = document.getElementById('contactmap');
      if (mapInput) {
        mapInput.value = '';
      }
    },
    getCompanyAddressData(addressData) {
      if (!addressData) return;
      
      this.registerCompany.address.state = addressData.administrative_area_level_1 || '';
      this.registerCompany.address.city = addressData.administrative_area_level_2 || '';
      
      const streetNumber = addressData.street_number || '';
      const route = addressData.route || '';
      this.registerCompany.address.street_address = `${streetNumber} ${route}`.trim();
      
      this.registerCompany.address.country = addressData.country || '';
      this.registerCompany.address.postcode = addressData.postal_code || '';
      this.registerCompany.address.suburb = addressData.locality || '';
    },
    submitRegistration() {
      if (!this.registerCompany.admin_email) {
        this.registrationError = 'Admin email is required.';
        return;
      }

      const emails = [...new Set([this.registerCompany.admin_email, ...this.registerCompany.user_emails.filter(email => email)])];

      const payload = {
        company_name: this.registerCompany.company_name,
        facility_name: this.registerCompany.facility_name,
        state_id: this.registerCompany.state_id,
        company_type: this.registerCompany.company_type,
        address: this.registerCompany.address,
        contact_methods: this.registerCompany.contact_methods,
        emails: emails,
        ecdr_active: this.registerCompany.ecdr_active,
        patient_admin_active: this.registerCompany.patient_admin_active,
        eprescribing_active: this.registerCompany.eprescribing_active,
        reporting_active: this.registerCompany.reporting_active,
        enmrc_eprescribing_active: this.registerCompany.enmrc_eprescribing_active,
        patient_own_bags_active: this.registerCompany.patient_own_bags_active,
        requisitions_active: this.registerCompany.requisitions_active,
        batch_features_active: this.registerCompany.batch_features_active,
        analytics_active: this.registerCompany.analytics_active
      };

      this.registrationError = '';
      this.displaySuccessModal = true;
      this.successMessage = 'Submitting company registration details...'

      axios.post(`/onload-company`, payload).then(res => {
        this.displaySuccessModal = false;
        const responseData = Array.isArray(res.data) ? res.data : [];
        this.onboardingResults = emails.map((email, index) => ({
          email,
          role: index === 0 ? 'Admin' : 'User',
          password: responseData[index] || null
        }));
      }).catch(err => {
        this.displaySuccessModal = false;
        this.registrationError = err?.response?.data?.message || err?.response?.data || 'Something went wrong submitting the registration.';
      })
    },
    retrieveStates() {
      axios.post('/get-states', {}).then(res => {
        this.states = res.data;
      }).catch(err => {
        console.log('this is the state error', err.response.data);
      })
    },
    getTimezones() {
      axios.post('/get-timezones', {}).then(res => {
        this.timezones = res.data;
      }).catch(err => {
        console.log('err issss', typeof err.response.data);
      })
    },
  },
  mounted() {
    this.getTimezones();
    this.retrieveStates();
    if (this.$route.path.includes('/warehouse/')) {
      this.registerCompany.company_type = 'warehouse';
    }
  }
}
</script>

<style lang="scss">
@import "../assets/css/main.scss";

.login-view {
  height: 100vh;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.login-context {
  background: linear-gradient(84.65deg, #10DCF4 31.37%, #0870DC 87.12%);
  color: white;
  padding-top: 8.125em;
  padding-left: 17em;
  padding-right: 8em;
  text-align: left;

  .login-logo {
    justify-content: flex-end;
  }

  h1 {
    font-size: 3.5em;
    font-weight: bold;
  }
}

.login-logo {
  justify-self: flex-start;
}

.login-form {
  padding: 8.125em 4.375em;
  border-bottom-right-radius: 8.25em;
  background-color: white;
  margin-right: -10em;
  z-index: 1;
  box-shadow: 10px 10px 25px 5px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  align-content: center;
  flex-direction: column;
}

.login-form-details {

  width: fit-content;
  justify-content: center;
  margin: 0 auto;
  margin-top: 10em;
  justify-self: center;
  display: flex;
  flex-direction: column;
  align-content: center;

  h2 {
    text-align: left;
  }
}

.login-form-fields {
  display: grid;
  justify-content: center;
}

.form-error {
  margin: 0;
  margin-bottom: 1em;
  color: #E04F39; //$error;
  font-weight: 500;
  text-align: left;
  padding-left: 10px;
  padding-top: 10px;
}

.feature-flags {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5em;
  font-size: 0.9em;

  label {
    display: flex;
    align-items: center;
    gap: 0.4em;
  }
}

.onboarding-results-table {
  border-collapse: collapse;
  width: 100%;
  margin-top: 1em;

  th, td {
    border: 1px solid #ccc;
    padding: 6px 12px;
    text-align: left;
  }

  th {
    background-color: #E5F1FE;
  }
}
</style>
